import React from "react";
import { Timeline, Events, UrlButton, ImageEvent } from "@merc/react-timeline";

// projects
import L_Jiocom from "../../assets/img/projects/jcom.webp";
import L_TradeServ from "../../assets/img/projects/tradeServUnif.webp";
import L_Medanta from "../../assets/img/projects/medanta.webp";
import L_Shivyog from "../../assets/img/projects/shivyog.webp";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import "./projects-timeline.styles.css";

const TimeLine = () => {
  return (
    <div>
      <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
      <Timeline>
        <Events>
          {/* Project: jio.com */}
          <ImageEvent date="May 2019 - Jan 2020" className="text-center" text="jio.com" src={L_Jiocom} alt="jio.com">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className="p-2 text-center accordian-main">
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong> A web app for jio taking care of features like recharge, pay-bill, vouchers, dashboard, store-locator, fiber order-tracking, auto-pay, etc
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li><span className="p-2">Next Js</span></li>
                          <li><span className="p-2">React</span></li>
                          <li><span className="p-2">Emotion Js</span></li>
                          <li><span className="p-2">Webpack</span></li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-center flex-nowrap text-center">
                <UrlButton href="https://www.jio.com/selfcare/recharge/" target="_blank">
                  SEE LIVE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: Tradeserv Unification */}
          <ImageEvent date="May 2017 - Apr 2019" className="text-center" text="Tradeserv Unification" src={L_TradeServ} alt="Tradeserv Unification">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className="p-2 text-center accordian-main">
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong>TradeServ is a tech stack, that provides provides end-to-end trade processing and workflow solutions for FX and credit trade confirmation, clearing and regulatory reporting services.
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li><span className="p-2"></span>Angular</li>
                          <li><span className="p-2"></span>Typescript</li>
                          <li><span className="p-2"></span>RxJs</li>
                          <li><span className="p-2"></span>Sass</li>
                        </ul>
                        <hr />
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://ihsmarkit.com/products/tradeserv-markitserv-credit-re-platform.html" target="_blank">
                  PRIOJECT DOCS
                </UrlButton>
                <UrlButton href="https://www.youtube.com/watch?v=-MiWrcbFlys" target="_blank">
                  WATCH VIDEO
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: Medanta */}

          <ImageEvent date="Jun 2016 - Apr 2017" className="text-center" text="Medanta" src={L_Medanta} alt="Medanta">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className="p-2 text-center accordian-main">
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong> Medanta e-connect is an interactive online solution made in AngularJS for Medanta hospital to manage and conduct patient appointments in the form of Tele-Call, Video Call, Mail/Chat, Hospital Visits etc.
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li><span className="p-2"></span>Angular Js</li>
                          <li><span className="p-2"></span>Bootstrap</li>
                          <li><span className="p-2"></span>Javascript</li>
                          <li><span className="p-2"></span>JQuery</li>
                          <li><span className="p-2"></span>HTML, CSS</li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton href="https://www.medanta.org/" target="_blank">
                  SEE LIVE
                </UrlButton>
                <UrlButton href="https://www.youtube.com/watch?v=Ko3VGlODIZo" target="_blank">
                  WATCH VIDEO
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: Shivyog Portal */}

          <ImageEvent date="Oct 2014 - May 2016" className="text-center" text="Shivyog Portal" src={L_Shivyog} alt="Shivyog Portal">
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className="p-2 text-center accordian-main">
                      PROJECT DETAILS
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong> The project application works in the form of a webapp which handles the modules organizing of events, registrations for events, admin-secret configurations, payment module, membership functionality, full registration data analysis reports, etc.
                        <hr />
                        <strong>Tech used:</strong>
                        <ul>
                          <li><span className="p-2"></span>Ember Js</li>
                          <li><span className="p-2"></span>Javascript</li>
                          <li><span className="p-2"></span>Bootstrap</li>
                          <li><span className="p-2"></span>HTML, CSS</li>
                          <li><span className="p-2"></span>Grunt</li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              <div className="d-flex justify-content-center flex-nowrap text-center">
                <UrlButton href="https://www.shivyogportal.com/" target="_blank">
                  SEE LIVE
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

        </Events>
      </Timeline>
    </div>
  );
};

export default TimeLine;
